module.exports = __webpack_public_path__ + "img/bg_99.b45827f6.jpg";